import axios from 'axios'
import {
	get,
	post,
	del
} from '@/http/request'
import {
	HOST
} from '@/http/config'


// 审批流列表
export function getProcessDefinitions(params) {
	return get(`${HOST}activity/process_definition/getProcessDefinitions`, params)
}
// 删除当前审批流
export function delDefinition(params) {
	return del(`${HOST}activity/process_definition/delDefinition`, params)
}
// 审批流列表 详情 渲染审批流文件
export function getDefinitionXML(params) {
	return get(`${HOST}activity/process_definition/getDefinitionXML`, params)
}
// 查询流程的所有用户节点
export function getUserTasks(params) {
	return get(`${HOST}activity/process_handler/getUserTasks`, params)
}
// app业务列表
export function appList(params) {
	return get(`${HOST}app-info/list/`, params)
}
// 部门下的app业务列表
export function applicationdetail(params) {
	return get(`${HOST}organization-info/applicationdetail`, params)
}
// 组织树
export function activitiTreeList(params) {
	return get(`${HOST}organization-info/treeList/`, params)
}
// 审批流第一次上传
export function uploadStreamAndDeploymentFirst(params) {
	return post(`${HOST}activity/process_definition/uploadStreamAndDeploymentFirst`, params)
}

// 升级审批流
export function uploadStreamAndDeployment(params) {
	return post(`${HOST}activity/process_definition/uploadStreamAndDeployment`, params)
}



// WEBPACK FOOTER //
// ./src/views/system/activitiList/api/api.js